import type { TrackedCategoryAssignment } from "@aircap/common/trackedCategory";

export const formatTrackedCategoryNames = (
  assignment: TrackedCategoryAssignment,
  resolveName: (categoryId: string) => string | undefined,
) => {
  switch (assignment.mode) {
    case "none":
      return null;
    case "single":
      return resolveName(assignment.trackedCategoryId) ?? assignment.trackedCategoryId;
    case "split":
      return assignment.splits
        .map((split) => resolveName(split.trackedCategoryId) ?? split.trackedCategoryId)
        .join(", ");
  }
};
